import React from 'react';
import { Col, Row } from 'react-bootstrap';
import Text from 'v3/components/Text';

export function LabelsRow() {
  return (
    <Row className="my-2">
      <Col md={2} />
      <Col className="text-left" md={1}>
        <Text type="label" color="dark" weight={500}>
          %
        </Text>
      </Col>
      <Col className="text-left" md={3}>
        <Text type="label" color="dark" weight={500}>
          R$
        </Text>
      </Col>
      <Col className="text-left" md={3}>
        <Text type="label" color="dark" weight={500}>
          $
        </Text>
      </Col>
      <Col md={3} />
    </Row>
  );
}
